// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b0d5ef31","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"c337ae4c","726":"15ab1c9a"}[chunkId] + ".chunk.js";
};